import { DocumentUtil } from './document.util';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';

export class GameDocumentUtil {

  public static getPDF(id: string, count) {
    DocumentUtil.hideScroll();
    const pdfElement = document.getElementById(id);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        html2canvas(pdfElement, { scale: 2 }).then(async canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jspdf('p', 'px', [1000, 1450], true);

          for (let i = 0; i < count; i++) {
            const c = await this.getImageParts(contentDataURL, i, count);
            const u = c.toDataURL('image/png');
            pdf.addImage(u, 'PNG', -100, 0, 1000, 1000 / c.width * c.height, `page-${i}`, 'medium');
            if (i !== count - 1) {
              pdf.addPage();
            }
          }
          resolve(pdf);
        }).finally(() => {
          DocumentUtil.showScroll();
        }).catch(reject);
      }, 2000);
    })
  }

  public static printDocument(id: string, count, fileName) {
    return GameDocumentUtil.getPDF(id, count).then((pdf: any) => {
      pdf.save(`${fileName}.pdf`);
      return true;
    });
  }

  private static getImageParts(contentDataURL, index, count): Promise<any> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const pageHeight = img.height / count - 10;
        canvas.width = img.width;
        canvas.height = pageHeight;

        ctx.drawImage(img, 0, pageHeight * index, img.width, pageHeight, 0, 0, canvas.width, pageHeight);
        resolve(canvas);
      };
      img.src = contentDataURL;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/gameDocument.util.ts